import React from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import InnerForm from '@App/kit/fields/v2/InnerForm'

interface UserInfoSectionProps {
    firstName: FormFieldType<string>
    lastName: FormFieldType<string>
    birthday: FormFieldType<Date | undefined>
}

const UserInfoSection = (props: UserInfoSectionProps) => {
    const { firstName, lastName, birthday } = props
    return (
        <section className="user-info-section">
            <h5>User Information</h5>
            <div className="fields-row-container">
                <InnerForm formFields={{ firstName, lastName, birthday }} />
            </div>
        </section>
    )
}
export default UserInfoSection
